import { ALL_UNITS_VALUE, FIRST_UNIT_INDEX } from '../../constants';
import useTranslation from '../useTranslation';
import { useEffect } from 'react';

import useAssetParts from 'hooks/useAssetParts';

import type { Props, UseData } from './types';

const useData = ({ assetId, partType }: Props): UseData => {
    const { ALL_UNITS, NO_UNITS_FOUND } = useTranslation();
    const { fetchAssetParts, isLoading, parts } = useAssetParts();

    useEffect(() => {
        fetchAssetParts({ assetId });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assetId]);

    const unitCount = parts.find(part => part.partType === partType)?.unitCount ?? 0;

    const numberedUnits = Array.from({ length: unitCount }, (_unit, index) => {
        const unitIndex = index + FIRST_UNIT_INDEX;

        return { label: `${unitIndex}`, value: `${unitIndex}` };
    });

    const unitItems = [{ label: ALL_UNITS, value: ALL_UNITS_VALUE }, ...numberedUnits];

    return { isLoading, noItemsText: NO_UNITS_FOUND, unitItems };
};

export default useData;
